<!--
  Селект интеграции Saby для ЭДО-операций.
  Показывает включённые Saby-интеграции и автоподставляет значение, только если вариант один.
-->
<template>
  <base-select
    :model-value="modelValue"
    :options="options"
    :placeholder="placeholderText"
    :invalid="invalid"
    :clearable="clearable"
    @update:model-value="handleUpdate"
    @change="handleChange"
  />
</template>

<script>
import { useIntegrationStore } from "@/stores/integrationStore";
import { edoSabyIntegrationLabel } from "@/utils/edoIntegrationLabel";

export default {
  name: "SabyIntegrationSelect",

  props: {
    modelValue: {
      type: [String, Number],
      default: null,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    autoSelectSingle: {
      type: Boolean,
      default: true,
    },
  },

  emits: ["update:modelValue", "change"],

  computed: {
    integrationStore() {
      return useIntegrationStore();
    },

    enabledSabyIntegrations() {
      return this.integrationStore.sabyIntegrations.filter(
        (integration) => integration.enabled
      );
    },

    options() {
      return this.enabledSabyIntegrations.map((integration) => ({
        value: integration.id,
        label: this.integrationLabel(integration),
      }));
    },

    placeholderText() {
      if (this.integrationStore.dataIsLoading) return "Загружаем интеграции...";
      if (!this.options.length) return "Нет включённых интеграций Saby";
      return "Выберите интеграцию Saby";
    },
  },

  watch: {
    options: {
      immediate: true,
      handler(options) {
        if (this.autoSelectSingle && !this.modelValue && options.length === 1) {
          this.setValue(options[0].value, true);
        }
      },
    },
  },

  async created() {
    if (!this.integrationStore.integrations.length) {
      await this.integrationStore.fetchIntegrations();
    }
  },

  methods: {
    integrationLabel(integration) {
      return edoSabyIntegrationLabel(integration);
    },

    setValue(value, emitChange = false) {
      this.$emit("update:modelValue", value);
      if (emitChange) this.$emit("change", value);
    },

    handleUpdate(value) {
      this.setValue(value);
    },

    handleChange(option) {
      const value = option && typeof option === "object" ? option.value : option;
      this.$emit("change", value);
    },
  },
};
</script>
